import axios from "axios";
import { Post } from "./apiHelper";

export interface AttachmentData {
  s3ResourceURL: string;
  s3ResourceKey: string;
  fileName: string;
  id?: number;
  downloadLink?: string;
}

export enum BucketTypes {
  ATTACHMENT = "attachment",
  PROFILE_PIC = "profilePic",
  PRESCRIPTION = "prescription"
}

export enum AttachmententityNames {
  assessment = "assessment",
  user = "user",
  resourceCentre = "resourceCentre",
  labTest = "labTest", // used as labTest in db but is for labTestRecord
  banner = "banner",
  insuranceImage = "clientInsuranceImage",
  stockTransaction = "stockTransaction",
  assessmentTemplateImage = "assessmentTemplateImage"
}

const attachmentsRoot = "/api/attachments";

export const getPresignedPostDataForAttachment = async ({
  fileName,
  bucketType
}: {
  fileName: string;
  bucketType: BucketTypes;
}): Promise<unknown> => {
  const response = await Post(
    `${attachmentsRoot}/createPresignedPost`,
    { fileName, bucketType },
    true
  );
  return response.data;
};

export const uploadAttachment = async ({
  imageData,
  bucketType = BucketTypes.ATTACHMENT
}: {
  imageData: Blob;
  bucketType?: BucketTypes;
}): Promise<{ s3ResourceURL: string; s3ResourceKey: string; fileName: string }> => {
  const fileName = `${Date.now()}.${imageData.type.split("/")[1]}`;

  const postData = (await getPresignedPostDataForAttachment({
    fileName,
    bucketType
  })) as {
    id: number;
    data: Record<string, unknown> & { fields: Record<string, string>; url: string };
  };

  const s3FileName = `${postData.id}/${fileName}`;

  const formData = new FormData();
  Object.entries(postData.data.fields).forEach(([key, value]) => {
    formData.append(key, value);
  });
  formData.append("file", imageData, s3FileName);

  const response = await axios.post(postData.data.url, formData, {
    headers: { "Content-Type": "application/octet-stream" }
  });

  const imageUrl =
    response.headers.location || `${postData.data.url}/${postData.data.fields.key}` || "";

  const imageKey = postData.data.fields.key as string;

  return { s3ResourceURL: imageUrl, s3ResourceKey: imageKey, fileName };
};

export const saveAttachments = async ({
  entityId,
  entityName,
  attachments
}: {
  entityId: number;
  entityName: AttachmententityNames;
  attachments: AttachmentData[];
}): Promise<unknown> => {
  const response = await Post(
    `${attachmentsRoot}/save`,
    { entityId, entityName, attachments },
    true
  );
  return response.data;
};
